<template>
    <EChart
        :options="chartOptions"
        :error="request.getError()"
        :loading="request.getLoading()"
        type="time"
        card
        class="m-0"
        :header="$t('numberOfOffersInTime')"
        :tooltip="$t('tooltip')"
    />
</template>



<script>
    import EChart from '@/components/common/EChart.vue';

    export default {
        name: 'OffersInTime',
        components: {
            EChart,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.parentComponent.requestData,
            };
        },
        computed: {
            data() {
                return this.parentComponent.data;
            },
            chartData() {
                return this.request.getData();
            },
            chartSeries() {
                /* eslint-disable no-restricted-syntax, guard-for-in */
                // Agregacja zdarzeń wg kampanii — wersja zoptymalizowana:
                // zamiast trzymać tablice zdarzeń, trzymamy sumy delt w Map<timestamp, delta>
                const deltasByCampaign = new Map();

                Object.values(this.data || {}).forEach(productObj => {
                    const charts = productObj.charts || {};
                    Object.keys(charts).forEach(chartKey => {
                        charts[chartKey].forEach(chartObj => {
                            const offer = chartObj.offer;
                            const campaign = offer?.campaign || 'unknown';
                            const segments = chartObj?.chart?.segments || [];
                            if (segments.length === 0) return;

                            let grouped = deltasByCampaign.get(campaign);
                            if (!grouped) {
                                grouped = new Map();
                                deltasByCampaign.set(campaign, grouped);
                            }

                            segments.forEach(segment => {
                                const tStart = typeof segment.start === 'number' ? segment.start : Number(segment.start);
                                const tEnd = typeof segment.end === 'number' ? segment.end : Number(segment.end);

                                grouped.set(tStart, (grouped.get(tStart) || 0) + 1);
                                grouped.set(tEnd, (grouped.get(tEnd) || 0) - 1);
                            });
                        });
                    });
                });

                const series = [];
                for (const [campaign, grouped] of deltasByCampaign.entries()) {
                    const times = Array.from(grouped.keys()).sort((a, b) => a - b);
                    let cumulative = 0;
                    const dataPoints = [];
                    times.forEach(time => {
                        cumulative += grouped.get(time) || 0;
                        dataPoints.push({ x: time, y: cumulative });
                    });
                    series.push({
                        name: campaign,
                        data: dataPoints,
                    });
                }
                return series;
                /* eslint-enable no-restricted-syntax, guard-for-in */
            },
            chartOptions() {
                if (!this.chartData) {
                    return { series: [] };
                }
                const series = this.chartSeries.map(item => ({
                    name: item.name,
                    type: 'line',
                    step: 'end',
                    areaStyle: null,
                    data: item.data.map(pt => [pt.x, pt.y]),
                }));
                return {
                    xAxis: {
                        type: 'time',
                    },
                    yAxis: {
                        type: 'value',
                    },
                    series,
                };
            },
        },
    };
</script>



<i18n lang="json" locale="pl" scope="local">
{
    "tooltip": "Wykres prezentuje liczbę ofert w sklepach wyświetlanych w widgecie (domyślne ustawienia). Aby sprawdzić liczbę ofert w pozostałych sklepach, użyj filtra Sklep."
}
</i18n>

<i18n lang="json" locale="en" scope="local">
{
    "tooltip": "The chart presents the number of offers in stores displayed in the widget (default settings).To check the number of offers in other stores, use the shop filter."
}
</i18n>
